import { AbwaabLogoHorizontal, AbwaabCover } from '@Assets/Brand'

/**
 * Default brand assets used when the backend `settings.assets` does not provide
 * an override. Defaults to the AbwaabPlus brand lockup + cover.
 */
export const defaultAssets = {
	logo: AbwaabLogoHorizontal,
	landing_main: AbwaabCover,
}
